module.exports = __webpack_public_path__ + "img/instagram-lg.ac2fcf73.svg";